import React from "react";
import { Box, Chip, Paper, Typography } from "@mui/material";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import type { OwnerVoiceSettings } from "../../api/voiceSettings";

export function ChatStatusSummary({
  settings,
}: {
  settings: OwnerVoiceSettings;
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: "14px",
        border: "1px solid #E2E8F0",
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 1.25, alignItems: "flex-start" }}>
          <ChatBubbleOutlineRoundedIcon sx={{ color: "#C9734F", mt: 0.25 }} />
          <Box>
            <Typography sx={{ fontWeight: 700, color: "#0F172A" }}>
              Chat channel
            </Typography>
            <Typography sx={{ mt: 0.75, fontSize: "0.9rem", color: "#475569" }}>
              Webchat and messaging use the saved assistant style immediately.
            </Typography>
          </Box>
        </Box>
        <Chip
          label="Live after save"
          size="small"
          sx={{
            backgroundColor: "#F0FDF4",
            color: "#15803D",
            fontWeight: 700,
          }}
        />
      </Box>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        <Box>
          <Typography sx={{ fontSize: "0.72rem", color: "#94A3B8", mb: 0.5 }}>
            Greeting
          </Typography>
          <Typography sx={{ fontSize: "0.88rem", color: "#0F172A" }}>
            {settings.chat_greeting ? "Configured" : "Not configured"}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ fontSize: "0.72rem", color: "#94A3B8", mb: 0.5 }}>
            Sync
          </Typography>
          <Typography sx={{ fontSize: "0.88rem", color: "#0F172A" }}>
            No admin sync needed
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}
